// googleMapOptions.ts
type AnyObj = Record<string, any>;

function isPlainObject(v: unknown): v is AnyObj {
    return typeof v === "object" && v !== null && !Array.isArray(v);
}

function deepMerge<T extends AnyObj>(base: T, overrides?: Partial<T>): T {
    if (!overrides) return base;

    const out: AnyObj = { ...base };
    for (const [k, v] of Object.entries(overrides)) {
        if (v === undefined) continue;

        const baseVal = out[k];
        if (isPlainObject(baseVal) && isPlainObject(v)) out[k] = deepMerge(baseVal, v);
        else out[k] = v;
    }
    return out as T;
}

// ✅ match what <Map /> expects: MapOptions WITHOUT these keys
export type VisMapOptions = Omit<google.maps.MapOptions, "colorScheme" | "renderingType">;

export function buildSatelliteMapOptions(
    overrides?: Partial<VisMapOptions>
): Partial<VisMapOptions> {
    if (!window.google?.maps) return overrides ?? {};

    const base: Partial<VisMapOptions> = {
        mapTypeId: window.google.maps.MapTypeId.SATELLITE,
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: window.google.maps.ControlPosition.TOP_RIGHT,
        },
        zoomControl: true,
        zoomControlOptions: {
            position: window.google.maps.ControlPosition.RIGHT_CENTER,
        },
        scaleControl: true,
        streetViewControl: true,
        streetViewControlOptions: {
            position: window.google.maps.ControlPosition.RIGHT_TOP,
        },
        fullscreenControl: true,
        fullscreenControlOptions: {
            position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        rotateControl: true,
        clickableIcons: true,
        disableDefaultUI: false,
        keyboardShortcuts: true,
    };

    return deepMerge(base as AnyObj, overrides as AnyObj) as Partial<VisMapOptions>;
}